/**
 * Entity types for multi-allocation
 */
export enum EntityType {
    MULTI_ALLOCATION_WORKSHEET = "MULTI_ALLOCATION_WORKSHEET",
    MULTI_ALLOCATION_SHEET = "MULTI_ALLOCATION_SHEET"
}
